import React, { Fragment, useState } from 'react'
import {
  ActionIconChevronBottom,
  ActionIconChevronRight,
  ItemTouchable,
  List,
  IconInformation,
  DesignTokens,
  View
} from '@klarna/bubble-ui'

export interface DisclaimerFrameProps {
  title: string
  items?: string
}

export default function DisclaimerFrame({ title, items }: DisclaimerFrameProps) {
  if (!title) return null
  const [expanded, setExpanded] = useState(false)

  const designContext = DesignTokens.useDesignContext()
  const alertBackgroundColor = designContext.get<DesignTokens.Color>('colors/backgrounds/accent-inline').toString()
  const transparentBackgroundColor = designContext.get<DesignTokens.Color>('colors/backgrounds/transparent').toString()
  const itemListMargingLeft = designContext.get<DesignTokens.Size>('space/400').value()
  const itemPositions = 'centered-exclude-slot-bottom'

  return (
    <Fragment>
      <ItemTouchable
        framed
        UNSAFE_style={{ backgroundColor: alertBackgroundColor }}
        title={title}
        onPress={!items ? null : () => setExpanded(!expanded)}
      >
        <ItemTouchable.SlotLeft position={itemPositions}>
          <IconInformation filled colorToken='colors/text/accent-on-background' />
        </ItemTouchable.SlotLeft>

        {items && <ItemTouchable.SlotRight position={itemPositions}>
          {expanded ? <ActionIconChevronBottom noWrapper /> : <ActionIconChevronRight noWrapper />}
        </ItemTouchable.SlotRight>
        }

        <ItemTouchable.SlotBottom>
          {expanded ? <View style={{
            backgroundColor: transparentBackgroundColor,
            marginLeft: itemListMargingLeft
          }}>
            <List>{items.split(',').map((item, index) => <List.Item key={`item-${index}`}>{item}</List.Item>)}</List>
          </View>
            : ''
          }
        </ItemTouchable.SlotBottom>
      </ItemTouchable>
    </Fragment>
  )
}
